import axios from '@/axios.config.js';

class FileService {
    uploadFile(name, file, onUploadProgress) {
        const formData = new FormData();
        formData.append(name, file);
        return axios
            .post('files', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                onUploadProgress,
            }).then(response => {
                return response.data;
            });
    }

    downloadFile(url) {
        return axios
            .get(url, {
                addTokenToHeader : false,
            }).then(response => {
                return response;
            });
    }

    getFile(fileId) {
        return axios
            .get(`files/${fileId}`).then(response => {
                return response.data.link;
            });
    }

    getProductImage(imageId) {
        return axios
            .get(`products/images/${imageId}`).then(response => {
                return response.data.link;
            });
    }

}

export default new FileService();